import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, user, userType } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  } else if (!user.profile[userType]?.trackId)
    return <Redirect to="/notrack" />;
  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
